var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('ProjectOverviewBody',[_c('ProjectOverview',{attrs:{"title":"Haut Comme 3 Pommes","description":"You play as a young boy who has the power to scale up and down objects around you. Depending of the objects' size, you can use them as swords, shields, rafts or even weapons of massive destruction !","tags":['C#', 'Unity', 'Tools', 'Project Management'],"keypoints":[
          'First 3D game on Unity',
          'Fast prototyping and production (3 months)',
          'Did all the code',
          'Tools for Sound & Narrative integration',
          'Project manager',
          'Showcased at Indiecade Europe 2019 !'
        ],"categories":[
          'Unity',
          'Unity',
          'C#',
          'Tools',
          'Project Management',
          'Misc'
      ],"timeline":"February - June 2019","team":"3 Game Designers & 3 Game Arts"}}),_c('ProjectOverviewVideo',{attrs:{"source":"hc3p/HC3P_Showreel.mp4","thumbnail":"hc3p/HC3P_BannerCropped.jpg"}}),_c('ProjectOverviewCarrousel',{attrs:{"images":[
          'hc3p/HC3P_Carrousel_4.jpg',
          'hc3p/HC3P_Carrousel_5.jpg',
          'hc3p/HC3P_Carrousel_6.jpg',
          'hc3p/HC3P_Carrousel_7.jpg',
          'hc3p/HC3P_Carrousel_8.jpg',
          'hc3p/HC3P_Carrousel_9.png',
          'hc3p/HC3P_Carrousel_10.png',
          'hc3p/HC3P_Carrousel_11.png'
      ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }